var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/**
 * Create advanced filtering to the query.
 *
 * @category Modifier
 * @param conditions Array of conditions to apply to the query.
 * @param filterType How conditions should be applied. Default is ALL_OF
 * @returns
 */
export function advancedFiltering(conditions, filterType = "ALL_OF") {
    return {
        klevuModifierId: "advancedFiltering",
        modifyAfter: (queries) => __awaiter(this, void 0, void 0, function* () {
            const copy = Array.from(queries);
            for (const q of copy) {
                if (!q.settings) {
                    q.settings = {};
                }
                q.settings.groupCondition = {
                    groupOperator: filterType,
                    conditions,
                };
            }
            return copy;
        }),
    };
}
